import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	favorite_destinations: [],
	loading: false,
	loadingSubmit: false
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_FAVORITE_DESTINATIONS_REQUEST:
		case ActionTypes.GET_FAVORITE_DESTINATIONS_ERROR:
		case ActionTypes.GET_FAVORITE_DESTINATIONS_SUCCESS:
		case ActionTypes.SUBMIT_FAVORITE_DESTINATION_REQUEST:
		case ActionTypes.SUBMIT_FAVORITE_DESTINATION_ERROR:
		case ActionTypes.SUBMIT_FAVORITE_DESTINATION_SUCCESS:
		case ActionTypes.DELETE_FAVORITE_DESTINATION_BY_ID_REQUEST:
		case ActionTypes.DELETE_FAVORITE_DESTINATION_BY_ID_ERROR:
		case ActionTypes.DELETE_FAVORITE_DESTINATION_BY_ID_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_FAVORITE_DESTIONATION_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_FAVORITE_DESTIONATION_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
